import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import classNames from 'classnames/bind';

import Heading from 'components/shared/heading';
import AppButton from 'components/shared/app-button';

import shape from './images/shape.svg';

import styles from './compact-download-application.module.scss';

const cx = classNames.bind(styles);

const CompactDownloadApplication = ({ title }) => {
  const {
    wp: {
      globalFields: {
        acf: { appStoreUrl, googlePlayUrl },
      },
    },
  } = useStaticQuery(
    graphql`
      {
        wp {
          globalFields {
            acf {
              appStoreUrl
              googlePlayUrl
            }
          }
        }
      }
    `
  );

  return (
    <section className={cx('wrapper')}>
      <div className="container">
        <Heading className={cx('title')} tag="h2" innerHTML={title} />
        <div className={cx('buttons-wrapper')}>
          <AppButton className={cx('button')} type="appStore" href={appStoreUrl} />
          <AppButton className={cx('button')} type="googlePlay" href={googlePlayUrl} />
        </div>
        <img className={cx('shape')} src={shape} alt="" loading="lazy" aria-hidden />
      </div>
    </section>
  );
};

CompactDownloadApplication.propTypes = {
  title: PropTypes.string.isRequired,
};

export default CompactDownloadApplication;
